import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const nodeSelector = createSelector(rootSelector, v => v.node);
export const nodeCodeSelector = createSelector(nodeSelector, n => n?.code);
export const nodeIdSelector = createSelector(nodeSelector, n => n?.nodeId);
export const nodeNameSelector = createSelector(nodeSelector, n => n?.name);
export const nodeBackgroundMediaURLSelector = createSelector(nodeSelector, n => n?.backgroundMediaURL);
export const nodeItemContainersSelector = createSelector(nodeSelector, n => n?.itemContainers);
export const nodeCustomPagesSelector = createSelector(
  nodeItemContainersSelector,
  itemContainers => itemContainers?.customPages || []
);
export const nodeDashboardsSelector = createSelector(
  nodeItemContainersSelector,
  itemContainers => itemContainers?.dashboard || []
);
export const nodeCustomHomePageIdSelector = (nodeId: number) =>
  createSelector(
    nodeCustomPagesSelector,
    nodeCustomPages =>
      nodeCustomPages
        ?.map(v => v.configNodes)
        .reduce((acc, cur) => acc.concat(cur), [])
        .find(v => v.nodeId === nodeId && v.isHomePage)?.itemContainerId
  );
